import { render } from "./DashboardCreate.vue?vue&type=template&id=98ba19dc"
import script from "./DashboardCreate.vue?vue&type=script&lang=js"
export * from "./DashboardCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__